import { hexToRgba } from "../utilities/hexToRGBA";

export const CustomTheme = {
	colors: {
		elevation1: "#414042", // dark gray main panel
		elevation2: "#272727", // darkest gray
		elevation3: "#171718", // near black input background
		modalBackground: hexToRgba("#171718", 0.97),
		modalBackgroundDragging: hexToRgba("#171718", 0.3),
		accent1: "#0070f3", // blue
		accent2: "#007bff", // light blue blue
		accent3: "#D3D5D6", // light gray icon color
		highlight1: "#6D6E71", // dark gray svg shading background
		highlight2: "#D3D5D6", // gray main panel text color
		highlight3: "#fefefe", // white
		vivid1: "#ffcc00",
		folderWidgetColor: "$highlight2",
		folderTextColor: "$highlight3",
		toolTipBackground: "$highlight3",
		toolTipText: "$elevation2",
	},
	radii: {
		xs: "1vh",
		sm: "2vh",
		lg: "3vh",
	},
	space: {
		xs: "1vh",
		sm: "2vh",
		md: "3vhx",
		rowGap: "2vh",
		colGap: "2vh",
	},
	fonts: {
		mono: "Inter, sans-serif",
		sans: "Inter, sans-serif",
	},
	fontSizes: {
		root: "12px",
		toolTip: "$root",
	},
	sizes: {
		rootWidth: "100%",
		controlWidth: "36%",
		svgWindowHeight: "100%",
		bezierWindowHeight: "69%",
		numberInputMinWidth: "10%",
		scrubberWidth: "8px",
		scrubberHeight: "16px",
		display: "grid",
		gridTemplateColumns: "auto auto",
		rowHeight: "38px",
		buttonHeight: "20px",
		folderTitleHeight: "20px",
		checkboxSize: "16px",
		joystickWidth: "100px",
		joystickHeight: "100px",
		colorPickerWidth: "$controlWidth",
		colorPickerHeight: "100px",
		imagePreviewWidth: "$controlWidth",
		imagePreviewHeight: "100px",
		monitorHeight: "20vh",
		titleBarHeight: "10vh",
	},
	shadows: {
		level1: "0 0 9px 0 #00000088",
		level2: "0 4px 14px #00000033",
	},
	borderWidths: {
		root: "0px",
		input: "1px",
		focus: "1px",
		hover: "1px",
		active: "1px",
		folder: "1px",
	},
	fontWeights: {
		label: "normal",
		folder: "normal",
		button: "normal",
	},
};
